export const parseDemandType = (demandType) => demandType?.split(' ')[0] || '';
